module.exports = vuedraggable_library;